import type { definitions } from '@luxuryescapes/contract-svc-lab-v2'
import type { LabV2Ui } from './evaluation'
import { triggerPointForPath } from './headerBanners'

type SnackbarUi = Extract<LabV2Ui, { type: 'snackbar' }>

export type LabV2SnackbarFrequency = 'once_per_session' | 'once_per_7_days' | 'once'

export type LabV2Snackbar = {
  id: number
  triggerPoints: SnackbarUi['trigger_points']
  displayFrequency: LabV2SnackbarFrequency
  kind: definitions['SnackbarPayload']['kind']
  heading: definitions['SnackbarPayload']['heading']
  description: definitions['SnackbarPayload']['description']
}

export const SNACKBAR_AFTER_POPUP_MS = 2000

function displayFrequency(frequency: SnackbarUi['display_frequency']): LabV2SnackbarFrequency {
  if (frequency === 'once' || frequency === 'once_per_7_days' || frequency === 'once_per_session') {
    return frequency
  }
  return 'once_per_session'
}

export function snackbarsFromUis(uis: Array<LabV2Ui> | undefined): Array<LabV2Snackbar> {
  if (!uis) {
    return []
  }

  const snackbars: Array<LabV2Snackbar> = []
  for (const ui of uis) {
    if (ui.type !== 'snackbar') {
      continue
    }
    snackbars.push({
      id: ui.id,
      triggerPoints: ui.trigger_points,
      displayFrequency: displayFrequency(ui.display_frequency),
      kind: ui.payload.kind,
      heading: ui.payload.heading,
      description: ui.payload.description,
    })
  }
  return snackbars
}

/** First qualifying snackbar for this page, in evaluate order. */
export function snackbarForPage(
  snackbars: Array<LabV2Snackbar>,
  path: string,
  regionCode?: string,
): LabV2Snackbar | undefined {
  const triggerPoint = triggerPointForPath(path, regionCode)
  if (!triggerPoint) {
    return undefined
  }

  return snackbars.find(snackbar => snackbar.triggerPoints.includes(triggerPoint))
}
